<div class="layer desktop-layer" (contextmenu)="showDesktopContextMenu($event)" (click)="manageDesktopClick($event)">
  <div class="full-size icons-safe-area">
    <app-context-menu menuId="icons-context-menu" [actions]="fileMenuActions" #iconsMenu></app-context-menu>
    <app-context-menu menuId="desktop-context-menu" [actions]="desktopMenuActions" #desktopMenu></app-context-menu>

    <div class="full-size d-flex flex-column align-content-start flex-wrap">
      <app-launcher *ngFor="let file of files" 
        #launcher
        (contextmenu)="showFileContextMenu($event, launcher, file)"
        (click)="manageClick($event, launcher, file)"
        [selected]="isSelected(file)"
        [name]="file.getName() | titlecase"
        [icon]="file.icon"
        [title]="file.path"
        [authenticationRequired]="file.security && file.security.authentication"
        class="pt-2 pl-2"
        style="width:{{iconSize.w}}px;height:{{iconSize.h}}px;"></app-launcher>
    </div>
  </div>
</div>